import ACTION_TYPES from "../actions/type.action";
import { ACTION_TYPE } from "../../whiteboard-react-konva/src/store/constants";

const initialState = {
  questions: {},
  happyquestions: {},
  conductquestions: {},
  attentionquestions: {},
  personalityquestions: {},
  responses: [],
  happyresponses: [],
  conductresponses: [],
  attentionresponses: [],
  personalityresponses: [],
  result: {},
  userAssessmentData: {},
  textualMemoryQuestions: [],
  visualMemoryQuestions: {
    correctImages: [],
    allImages: []
  },
  visualMemorySelectedImage: { imageUrl: "", index: -1 }
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ACTION_TYPES.FETCH_IQ_QUESTIONS:
      return {
        ...state,
        questions: [...payload]
      };
    case ACTION_TYPES.FETCH_HAPPINESS_QUESTIONS:
      return {
        ...state,
        happyquestions: [...payload]
      };
    case ACTION_TYPES.FETCH_CONDUCT_QUESTIONS:
      return {
        ...state,
        conductquestions: [...payload]
      };
    case ACTION_TYPES.FETCH_ATTENTION_QUESTIONS:
      return {
        ...state,
        attentionquestions: [...payload]
      };
    case ACTION_TYPES.FETCH_PERSONALITY_QUESTIONS:
      return {
        ...state,
        personalityquestions: [...payload]
      };
    case ACTION_TYPES.ADD_RESPONSES:
      return {
        ...state,
        responses: payload
      };
    case ACTION_TYPES.ADD_HAPPINESS_RESPONSES:
      return {
        ...state,
        happyresponses: payload
      };
    case ACTION_TYPES.ADD_CONDUCT_RESPONSES:
      return {
        ...state,
        conductresponses: payload
      };
    case ACTION_TYPES.ADD_ATTENTION_RESPONSES:
      return {
        ...state,
        attentionresponses: payload
      };
    case ACTION_TYPES.ADD_PERSONALITY_RESPONSES:
      return {
        ...state,
        personalityresponses: payload
      };
    case ACTION_TYPES.GET_IQRESULT:
      return {
        ...state,
        result: payload
      };
    case ACTION_TYPES.GET_USER_PROFILE:
      return {
        ...state,
        userAssessmentData: payload
      };
    case ACTION_TYPES.FETCH_TEXTUAL_MEMORY_QUESTIONS:
      return {
        ...state,
        textualMemoryQuestions: payload
      };
    case ACTION_TYPES.FETCH_VISUAL_MEMORY_QUESTIONS:
      return {
        ...state,
        visualMemoryQuestions: payload
      };
    case ACTION_TYPES.SUBMIT_TEXTUAL_MEMORY_QUESTIONS:
      return {
        ...state,
        userAssessmentData: payload
      };
    case ACTION_TYPES.SUBMIT_VISUAL_MEMORY_QUESTIONS:
      return {
        ...state,
        userAssessmentData: payload
      };
    case ACTION_TYPES.CHANGE_VISUAL_MEMORY_IMAGE:
      return {
        ...state,
        visualMemorySelectedImage: payload
      };
    case ACTION_TYPES.CHANGE_VISUAL_MEMORY_IMAGE_RESET:
      return {
        ...state,
        visualMemorySelectedImage: { imageUrl: "", index: -1 }
      };
    default:
      return state;
  }
};

export default reducer;
